var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportreportsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "26px",
    viewBox: "0 0 21 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Excel_O") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large_review",
    transform: "translate(-29.000000, -623.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_large"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(25.000000, 424.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 184.000000)",
    id: "Excel_O"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75,5.25 L17.75,5.25 L17.75,23.75 L-0.75,23.75 L-0.75,0.25 L12.75,0.25 L12.75,5.25 Z M12.8613652,0.191888364 L17.8099126,5.18132928 L16.744897,6.23761603 L11.7963496,1.24817511 L12.8613652,0.191888364 Z",
    id: "Combined-Shape",
    stroke: "#92CDE7",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-7",
    fill: "#92CDE7",
    points: "12 2 14.0090942 2.99121094 15 6 12 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "X",
    fill: "#92CDE7",
    points: "3.85644531 18 7.328125 12.6606445 4.01025391 7.16015625 6.63964844 7.16015625 8.84423828 10.8076172 11.2319336 7.16015625 13.0556641 7.16015625 9.73046875 12.2724609 13.1728516 18 10.5507812 18 8.19970703 14.1254883 5.68017578 18"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportreportsActive);
export default __webpack_public_path__ + "static/media/exportreports-active.0f1d3ddc75b6a98e9bd1d0061266a1ca.svg";
export { ForwardRef as ReactComponent };